import { o_global } from "@gr-common/head/namespaces";
import { eventQBus } from "./q-bus/index.js";

/*                                              */
o_global.eventQBus ||= eventQBus();
o_global.events ||= () => o_global.eventQBus as never;
